import { email, getRawDateFormatValidator, phoneNumber, required } from '../../../../../../utils/validators';
import { BulkAddClientRecord, csvHeaders, propFromHeader } from '../types';

export type ValidationErrors = Record<keyof BulkAddClientRecord, string | undefined>;

export const DOB_FORMAT = 'MM/dd/yyyy';

// Cache the validation results for date format validation, there can be a lot of rows and date format validation is expensive
const dateFormatValidationCache: Record<string, string | null> = {};
const validateDateWithCache = (value: string): string | undefined => {
    if (!value) return undefined;

    if (dateFormatValidationCache[value] === undefined) {
        dateFormatValidationCache[value] = getRawDateFormatValidator(DOB_FORMAT, 'MM/DD/YYYY')(value) || null;
    }
    return dateFormatValidationCache[value] || undefined;
};

export const validateRecord = (record: BulkAddClientRecord): ValidationErrors => ({
    clientFirstName: required(record.clientFirstName) || undefined,
    clientLastName: required(record.clientFirstName) || undefined,
    clientDOB: validateDateWithCache(record.clientDOB) || undefined,
    pointOfContactEmail: email(record.pointOfContactEmail) || undefined,
    pointOfContactPhoneNumber: phoneNumber(record.pointOfContactPhoneNumber) || undefined,
    pointOfContactFirstName: required(record.pointOfContactFirstName) || undefined,
    pointOfContactLastName: required(record.pointOfContactLastName) || undefined,
    pointOfContactPreferredName: undefined,
    clientPreferredName: undefined,
});

export const hasErrors = (record: BulkAddClientRecord): boolean => {
    const errors = validateRecord(record);
    return Object.values(errors).some((error) => !!error);
};

export const getRowErrors = (record: BulkAddClientRecord): (string | undefined)[] => {
    const errors = validateRecord(record);
    return csvHeaders.map((header) => errors[propFromHeader(header)]);
};

export const emptyBulkAddClientRecord: BulkAddClientRecord = {
    clientFirstName: '',
    clientLastName: '',
    clientDOB: '',
    clientPreferredName: '',
    pointOfContactEmail: '',
    pointOfContactPhoneNumber: '',
    pointOfContactFirstName: '',
    pointOfContactLastName: '',
    pointOfContactPreferredName: '',
};
